import React, { useEffect } from 'react'
import Additional from './Additional'
import Comment from './Comment'

const Reactjs = () => {
  useEffect(() => {
    window.scrollTo(900, 900);
  }, []);

  return (
    <div>
        <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div className="container py-5">
    <div className="row g-5">
      <div className="col-lg-8">
        {/* Course Detail Start */}
        <div className="mb-5">
          <h1 className="mb-4">React.js Fullstack Developer</h1>
          <p>Learn the ins and outs of building modern web applications using React.js, a popular JavaScript library for building user interfaces. This course covers the fundamentals of React.js along with backend integration to create fullstack applications. Our experienced instructors guide you through hands-on exercises and real-world projects to prepare you for a successful career in web development.</p>
          
          {/* Course Outline */}
          <b>Session 1: Introduction to React.js</b>
          <p>Introduction to React.js, JSX syntax, components, props, state</p>
          
          <b>Session 2: Component Lifecycle</b>
          <p>Component lifecycle methods, state management, hooks</p>
          
          <b>Session 3: Routing with React Router</b>
          <p>Setting up routing, navigating between pages, route parameters</p>
          
          <b>Session 4: Managing State with Redux</b>
          <p>Introduction to Redux, actions, reducers, connecting Redux to React</p>
          
          <b>Session 5: API Integration</b>
          <p>Fetching data from APIs, handling asynchronous operations</p>
          
          <b>Session 6: Forms and User Input</b>
          <p>Creating forms, handling form data, validation</p>
          
          <b>Session 7: Styling and CSS-in-JS</b>
          <p>Styling components, CSS-in-JS libraries, responsive design</p>
          
          <b>Session 8: Advanced React Patterns</b>
          <p>Higher-order components, render props, context API</p>
          
          <b>Session 9: Testing React Applications</b>
          <p>Unit testing, integration testing, testing libraries</p>
          
          <b>Session 10: Redux State Management</b>
          <p>Enhance your React applications with Redux, a popular state-management library.</p>
          
          <b>Session 11: Authentication and Authorization</b>
          <p>Implementing user authentication and authorization in React applications</p>
          
          <b>Session 12: Deployment</b>
          <p>Deploying React applications to hosting platforms</p>
          
          <b>Session 13: Real-time Applications</b>
          <p>Introduction to real-time features using WebSockets or other technologies</p>
          
          <b>Session 14: Performance Optimization</b>
          <p>Optimizing React applications for performance</p>
          
          <b>Session 15: Final Project</b>
          <p>Building a fullstack React application from scratch</p>
        </div>
        {/* Blog Detail End */}
              {/* Comment List Start */}
              <Comment/>
              {/* Comment Form End */}
            </div>
            {/* Sidebar Start */}
            <div className="col-lg-4">
              {/* Search Form Start */}
              <Additional/>
              {/* Plain Text End */}
            </div>
            {/* Sidebar End */}
          </div>
        </div>
      </div>

    </div>
  )
}

export default Reactjs